import { Toolbar } from '@mui/material';
import { Box } from '@mui/system';
import { ErrorAlertComponent } from 'lib/ErrorAlert';
import { Role } from 'lib/types';
import { PropsWithChildren, Suspense } from 'react';
import { Outlet } from 'react-router';
import { useLayoutConstants } from './Constants';
import { GlobalMenuBar } from '@/components/GlobalMenuBar';
import { useAuth } from '@/hooks/useAuth';
import { useResourceFilter } from '@/hooks/useResourceFilter';

export const AppShell = ({ children }: PropsWithChildren) => {
  const { profile } = useAuth();
  const { isRestricted } = useResourceFilter();
  // hideWhenRestricted: リソース制限ありのアドミンには表示しないページ
  const ALL_PAGES: { label: string; to: string; roles: Role[]; hideWhenRestricted?: boolean }[] = [
    { label: 'ロケーション', to: '/location', roles: ['superadmin', 'general', 'signal'] },
    { label: 'プロジェクト', to: '/projects', roles: ['superadmin', 'general'] },
    {
      label: 'プロジェクトグループ',
      to: '/projectgroups',
      roles: ['superadmin', 'general'],
      hideWhenRestricted: true,
    },
    {
      label: 'Joybitシミュレーター',
      to: '/joybitsimulator',
      roles: ['superadmin', 'general', 'signal'],
    },
    {
      label: 'クライアントユーザー',
      to: '/clientusers',
      roles: ['superadmin', 'general'],
      hideWhenRestricted: true,
    },
  ];

  const role = profile?.role;
  const pages = role
    ? ALL_PAGES.filter((p) => p.roles.includes(role)).filter(
        (p) => !(isRestricted && p.hideWhenRestricted),
      )
    : [];

  const { global } = useLayoutConstants();

  return (
    <Box
      sx={{ display: 'flex', height: '100vh', minWidth: global.minWidth }}
      justifyContent={'center'}
    >
      <GlobalMenuBar pages={pages} minWidth={global.minWidth} />
      <Box
        maxWidth='xl'
        sx={{ display: 'flex', flexDirection: 'column', flexGrow: 1, overflow: 'auto' }}
        py={1}
        px={3}
      >
        <Toolbar />
        <ErrorAlertComponent float />
        <Suspense fallback={null}>
          <Outlet />
          {children}
        </Suspense>
      </Box>
    </Box>
  );
};
